import * as React from 'react';

interface HamburgerContentWrapperProps {
    className: string;
    header: JSX.Element;
}

export const HamburgerContentWrapper: React.FC<React.PropsWithChildren<HamburgerContentWrapperProps>> = (props) => {
    return (
        <div className={props.className}>
            <div className="hamburger-tab-content scrollbar-wcf">
                {props.header}
                {props.children}
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerContentWrapper.tsx